import React from 'react';
import { View, Text } from 'react-native';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const QrCodeConfirmTransferPix = () => {
    return (
        <>
            <HeaderDefault title={<FormattedMessage id='qrCodeConfirmTransferPix.headerQrCode'/>} />

            <View style={styles.container}>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='qrCodeConfirmTransferPix.valorTransferencia'/></Text>
                    <Text><FormattedMessage id='qrCodeConfirmTransferPix.valorTransferenciaBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='qrCodeConfirmTransferPix.recebedor'/></Text>
                    <Text><FormattedMessage id='qrCodeConfirmTransferPix.txtNome'/></Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='qrCodeConfirmTransferPix.btnContinuar'/>} titlePage={<FormattedMessage id='qrCodeConfirmTransferPix.btnConfirmaTransferencia'/>} />
        </>
    );
}

export default QrCodeConfirmTransferPix;